import { ArrowRightAlt } from '@mui/icons-material';
import {
  Avatar,
  IconButton,
  Menu,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import { PropsWithChildren, useContext } from 'react';

import logo from '@/assets/logo.svg';
import { useAuth0Generic } from '@/hooks/auth';
import { stringAvatar, stringToColor } from '@/utils/strings';

import {
  IStationSwitcherContext,
  StationSwitcherContext,
} from '@components/providers/station/context';
import { ModalStationSelector } from '@components/providers/station/modal-station-selector';
import { AppBar as genAppBar } from '../dependencies';
import { ProfileMenuOptions } from './profile-menu-options';
import TopMenu from './top-menu';
import useLayout from './use-layout';

const drawerWidth = 250;

const AppBar = genAppBar(drawerWidth);

export default function DashboardTopLayout(props: PropsWithChildren) {
  const { handle_el, handleOpenUserMenu, handleCloseUserMenu } = useLayout();
  const { station, destStation } = useContext<IStationSwitcherContext>(
    StationSwitcherContext,
  );

  const { name } = useAuth0Generic();
  return (
    <div className="min-h-screen flex flex-col overflow-hidden bg-[#F8F9FD]">
      <AppBar
        color="inherit"
        position="relative"
        elevation={0}
        variant="outlined"
        sx={{ borderLeft: 'none', borderTop: 'none' }}
      >
        <Toolbar>
          <img src={logo} style={{ maxHeight: 38 }} alt="99Minutos logo" />
          <Typography ml={1} color="#072146" fontWeight="bold" component="sup">
            Clusters
          </Typography>

          <div className="ml-4 top-menu">
            <TopMenu />
          </div>

          <div className="ml-auto mr-2">
            {station ? (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography color="primary" fontWeight="bold" fontSize={14}>
                  {station?.station}
                  <sup>{station?.country}</sup>
                </Typography>
                <ArrowRightAlt fontSize="small" />
                <Typography color="secondary" fontWeight="bold" fontSize={14}>
                  {destStation?.station}
                  <sup>{destStation?.country}</sup>
                </Typography>
              </Stack>
            ) : (
              <Typography variant="caption" color="text.secondary">
                No hay estación seleccionada
              </Typography>
            )}
          </div>
          {name && (
            <>
              <Typography
                noWrap
                fontWeight="bold"
                color="primary"
                component="div"
                sx={{ marginRight: 1 }}
              >
                {name}
              </Typography>
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  sx={{
                    bgcolor: stringToColor(name || ''),
                  }}
                >
                  {stringAvatar(name || '')}
                </Avatar>
              </IconButton>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={handle_el}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={!!handle_el}
                onClose={handleCloseUserMenu}
              >
                <ProfileMenuOptions closeMenu={handleCloseUserMenu} />
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
      <div className="flex flex-grow overflow-y-auto">
        <main className="relative flex-1 transition-all duration-300 h-[calc(100vh-4rem)] bg-gray-100">
          {props.children}
        </main>
      </div>
      <ModalStationSelector />
    </div>
  );
}
